import { FC, useContext } from "react";
import { DrawerLinksToReportsComponent } from "./component";
import { ApiContext } from "../../contexts/api/context";
import {
  PowerBi,
  useGetMyPowerBisQuery,
} from "../../services/api/__generated__/backend_gateway-types";

export const DrawerLinksToReportsContainer: FC = () => {
  const { apiService } = useContext(ApiContext);

  const { data, loading, error } = useGetMyPowerBisQuery({
    client: apiService.getClient(),
  });

  if (error) {
    console.error(error.message);
  }

  return (
    <DrawerLinksToReportsComponent
      loading={loading}
      powerBis={(data?.getMyPowerBis || []) as PowerBi[]}
    />
  );
};
